import buildCatalogCategoryTree from './buildCatalogCategoryTree'
import getCollection from '../../utils/db/getCollection'
import loadOutletCategoryBranch from './outlet/loadOutletCategoryBranch'

export const loadRelatedCategoryTree = ({ brandIds = [] } = {}) =>
  Promise.all([
    getCollection({ path: 'globalCategories', docIdName: 'id' }),
    getCollection({ path: 'categories', docIdName: 'id' }),
    loadOutletCategoryBranch({ brandIds }),
  ]).then(([globalCategories, categories, outletBranch]) => {
    const premiumTree = buildCatalogCategoryTree({
      globalCategories,
      categories,
      brandIds,
    }).map((node) => ({
      ...node,
      source: 'premium',
    }))

    if (!outletBranch) {
      return premiumTree
    }

    return [...premiumTree, outletBranch]
  })

export default loadRelatedCategoryTree
